import { render, staticRenderFns } from "./ProductTileProtection.vue?vue&type=template&id=33b6c221&lang=html&"
import script from "./ProductTileProtection.vue?vue&type=script&lang=js&"
export * from "./ProductTileProtection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports